import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  Fade,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

export default function SaleProductActiveDialog({
  open,
  product,
  saving,
  error,
  onClose,
  onConfirm,
}) {
  function handleClose() {
    if (!saving) onClose?.();
  }

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      maxWidth={false}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      PaperProps={{
        sx: {
          bgcolor: "transparent",
          boxShadow: "none",
          borderRadius: "30px",
          overflow: "visible",
          m: 1.5,
        },
      }}
      slotProps={{
        backdrop: {
          timeout: 180,
          sx: {
            bgcolor: "rgba(2, 8, 23, 0.45)",
            backdropFilter: "blur(3px)",
          },
        },
      }}
    >
      <Fade in={Boolean(open)} timeout={180}>
        <Box
          sx={{
            width: "min(92vw, 460px)",
            bgcolor: "neutral.300",
            borderRadius: "30px",
            p: { xs: 2.2, sm: 2.7 },
            boxShadow: "0px 20px 60px rgba(0,0,0,.28)",
          }}
        >
          <Stack spacing={2}>
            <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
              <Typography sx={{ fontSize: 20, fontWeight: 800, color: "primary.900" }}>
                Desactivar producto
              </Typography>
              <IconButton
                type="button"
                size="small"
                disabled={saving}
                onClick={handleClose}
                aria-label="Cerrar confirmación"
              >
                <CloseIcon sx={{ color: "primary.900" }} />
              </IconButton>
            </Stack>

            <Box
              sx={{
                p: 2,
                borderRadius: "20px",
                bgcolor: "neutral.50",
                boxShadow: "inset 0px 0px 3px rgba(142,142,159,.35)",
              }}
            >
              <Typography sx={{ fontSize: 13, fontWeight: 700, color: "primary.900" }}>
                ¿Querés desactivar <strong>{product?.name}</strong>?
              </Typography>
              <Typography sx={{ mt: 0.7, fontSize: 11.5, color: "neutral.700" }}>
                Se conservarán su contenido y costo estimado. Podrás volver a activarlo si su composición continúa válida.
              </Typography>
            </Box>

            {error ? <Alert severity="error">{error}</Alert> : null}

            <Stack direction="row" spacing={1.2} sx={{ justifyContent: "flex-end" }}>
              <Button
                type="button"
                disabled={saving}
                onClick={handleClose}
                sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                variant="contained"
                color="error"
                disabled={saving}
                onClick={onConfirm}
                startIcon={saving ? <CircularProgress size={15} color="inherit" /> : null}
                sx={{ minWidth: 120, borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
              >
                {saving ? "Desactivando..." : "Desactivar"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Dialog>
  );
}
